var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLunaNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_2",
    "data-name": "Capa 2",
    viewBox: "0 0 1008.49 615.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: url(#Degradado_sin_nombre_6);\n        stroke-width: 6px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3, .cls-4 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-5 {\n        fill: #eb5527;\n      }\n\n      .cls-2 {\n        stroke-linejoin: round;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #ed7850;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-linecap: round;\n        stroke-width: 2px;\n      }\n\n      .cls-6 {\n        fill: #ed7851;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: #b73011;\n      }\n\n      .cls-9 {\n        fill: #ed7850;\n      }\n\n      .cls-4 {\n        stroke: #ed7851;\n      }\n\n      .cls-10 {\n        fill: #f7955d;\n      }\n\n      .cls-11 {\n        fill: url(#Degradado_sin_nombre_29);\n      }\n\n      .cls-12 {\n        fill: #999;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_29",
    "data-name": "Degradado sin nombre 29",
    cx: 552.34,
    cy: 287.35,
    fx: 423.43,
    fy: 795.68,
    r: 534.8,
    gradientTransform: "translate(-196.93 -130.12) scale(1.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ed7850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051432",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6",
    "data-name": "Degradado sin nombre 6",
    x1: 503.74,
    y1: 506.74,
    x2: 503.74,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#051432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#754440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#cb694b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed7850"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "146.76 615.94 .68 615.94 .68 514.4 146.76 514.4 192.84 565.24 146.76 615.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "353.58 514.4 169.63 514.4 215.71 565.24 169.63 615.94 353.58 615.94 399.66 565.24 353.58 514.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "794.43 514.4 610.48 514.4 656.56 565.24 610.48 615.94 794.43 615.94 840.51 565.24 794.43 514.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "817.82 514.4 817.82 515.4 863 565.24 817.82 614.95 816.79 615.94 1008.49 615.94 1008.49 514.4 817.82 514.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M624.14,24.68l-121.89,467.53L380.58,25.57c39.5-10.21,80.89-15.65,123.54-15.65s81.58,5.13,120.02,14.76ZM202.86,112.73l298.58,385.19L356.89,32.34c-56.33,17.63-108.34,45.1-154.03,80.39ZM97.59,223.73l401.14,277.97L186.2,126.17c-33.68,28.41-63.52,61.23-88.62,97.56ZM33.63,353.74l457.96,150.77L85.39,242.26c-21.64,34.54-39.13,71.93-51.76,111.48ZM10.37,501.01l474.84,7.15L25.81,380.87c-9.88,38.45-15.22,78.7-15.45,120.14ZM649.2,31.67l-144.76,466.25L803.91,111.59c-45.91-35.19-98.16-62.5-154.71-79.91ZM820.65,125.01l-313.49,376.69,402.73-279.08c-25.29-36.39-55.34-69.23-89.24-97.62ZM922.17,241.18l-407.87,263.33,460.09-151.48c-12.75-39.7-30.39-77.22-52.22-111.86ZM982.27,380.26l-461.6,127.9,477.2-7.19c-.23-41.64-5.62-82.09-15.6-120.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "uuid-732a3308-171b-410d-806d-1a6bb20c48a2",
    "data-name": "Capa 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M438.67,463.41h34.63c2.6,0,4.72,2.12,4.72,4.72v31.72c0,2.6,2.12,4.72,4.72,4.72h32.11c2.6,0,4.72-2.12,4.72-4.72v-57.44c0-11.45-9.3-20.75-20.75-20.75h-60.14c-1.26,0-2.49.52-3.38,1.41l-15.9,16.25c-1.8,1.84-1.8,4.8,0,6.62l15.88,16.07c.89.89,2.1,1.39,3.37,1.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M561.12,504.27c0,34.48-27.95,62.44-62.44,62.44-34.5,0-62.43-27.97-62.43-62.44,0-34.48,27.95-62.44,62.44-62.44,34.5,0,62.44,27.95,62.44,62.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M559.19,545.83h-34.63c-2.6,0-4.72-2.12-4.72-4.72v-31.72c0-2.6-2.12-4.72-4.72-4.72h-32.11c-2.6,0-4.72,2.12-4.72,4.72v57.46c0,11.45,9.3,20.75,20.75,20.75h60.16c1.26,0,2.49-.52,3.37-1.41l15.9-16.23c1.8-1.84,1.8-4.8,0-6.62l-15.9-16.07c-.89-.89-2.1-1.39-3.35-1.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M519.82,504.64c0,11.47-9.3,20.77-20.77,20.77-11.47,0-20.77-9.3-20.77-20.77,0-11.47,9.3-20.77,20.77-20.77,11.47,0,20.77,9.3,20.77,20.77"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M36.2,575.89c-1.3-.7-2.33-1.67-3.06-2.9-.74-1.23-1.11-2.61-1.11-4.15s.37-2.92,1.11-4.15c.74-1.23,1.76-2.2,3.06-2.9,1.3-.7,2.77-1.05,4.39-1.05s3.09.35,4.38,1.05c1.3.7,2.32,1.67,3.06,2.9s1.12,2.61,1.12,4.15-.37,2.92-1.12,4.15c-.75,1.23-1.77,2.2-3.06,2.9-1.3.7-2.76,1.05-4.38,1.05s-3.09-.35-4.39-1.05ZM43.1,573.21c.75-.43,1.33-1.02,1.76-1.78.42-.76.64-1.62.64-2.59s-.21-1.83-.64-2.59-1.01-1.35-1.76-1.78-1.58-.64-2.5-.64-1.76.21-2.5.64c-.75.42-1.33,1.02-1.75,1.78-.43.76-.64,1.63-.64,2.59s.21,1.83.64,2.59c.42.76,1.01,1.35,1.75,1.78.75.42,1.58.64,2.5.64s1.76-.21,2.5-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.86,576.67l-3.02-4.36h-3.33v4.36h-3.62v-15.66h6.78c1.39,0,2.59.23,3.61.69,1.02.46,1.81,1.12,2.36,1.97.55.85.83,1.86.83,3.02s-.28,2.17-.84,3.01c-.56.84-1.35,1.49-2.38,1.93l3.51,5.03h-3.89ZM60.95,564.67c-.57-.47-1.39-.7-2.48-.7h-2.95v5.46h2.95c1.09,0,1.92-.24,2.48-.72.57-.48.85-1.15.85-2.01s-.28-1.55-.85-2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M68.33,561.01h3.62v15.66h-3.62v-15.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M86.24,568.6h3.31v6.35c-.85.64-1.83,1.13-2.95,1.48s-2.24.51-3.38.51c-1.62,0-3.09-.35-4.38-1.04-1.3-.69-2.32-1.66-3.05-2.89-.74-1.23-1.11-2.62-1.11-4.17s.37-2.94,1.11-4.17c.74-1.23,1.76-2.19,3.08-2.88,1.31-.69,2.79-1.04,4.43-1.04,1.37,0,2.62.23,3.73.69,1.12.46,2.06,1.13,2.82,2.01l-2.33,2.15c-1.12-1.18-2.47-1.77-4.05-1.77-1,0-1.89.21-2.66.63s-1.38,1.01-1.81,1.77c-.43.76-.65,1.63-.65,2.62s.22,1.83.65,2.59c.43.76,1.03,1.35,1.8,1.78.77.42,1.64.64,2.63.64,1.04,0,1.98-.22,2.82-.67v-4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M105.03,573.76v2.91h-12.12v-15.66h11.83v2.91h-8.23v3.4h7.27v2.82h-7.27v3.62h8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M122.27,561.01v15.66h-2.97l-7.8-9.5v9.5h-3.58v-15.66h3l7.78,9.5v-9.5h3.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M257.23,573.76v2.91h-12.12v-15.66h11.83v2.91h-8.23v3.4h7.27v2.82h-7.27v3.62h8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M270.09,576.67l-3.02-4.36h-3.33v4.36h-3.62v-15.66h6.78c1.39,0,2.59.23,3.61.69,1.02.46,1.81,1.12,2.36,1.97.55.85.83,1.86.83,3.02s-.28,2.17-.84,3.01c-.56.84-1.35,1.49-2.38,1.93l3.51,5.03h-3.89ZM269.17,564.67c-.57-.47-1.39-.7-2.48-.7h-2.95v5.46h2.95c1.09,0,1.92-.24,2.48-.72.57-.48.85-1.15.85-2.01s-.28-1.55-.85-2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M286.94,561.71c1.02.46,1.81,1.12,2.36,1.97.55.85.83,1.86.83,3.02s-.28,2.15-.83,3.01-1.34,1.51-2.36,1.97c-1.02.46-2.22.68-3.61.68h-3.15v4.32h-3.62v-15.66h6.78c1.39,0,2.59.23,3.61.69ZM285.61,568.7c.57-.47.85-1.14.85-2s-.28-1.55-.85-2.02c-.57-.47-1.39-.7-2.48-.7h-2.95v5.43h2.95c1.09,0,1.92-.23,2.48-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M293.79,576.48c-.95-.25-1.71-.56-2.28-.93l1.16-2.5c.54.34,1.19.62,1.95.84.76.22,1.51.32,2.24.32,1.48,0,2.21-.37,2.21-1.1,0-.34-.2-.59-.6-.74-.4-.15-1.02-.28-1.86-.38-.98-.15-1.8-.32-2.44-.51s-1.2-.54-1.67-1.03-.7-1.19-.7-2.1c0-.76.22-1.44.66-2.02.44-.59,1.08-1.05,1.92-1.38.84-.33,1.84-.49,2.99-.49.85,0,1.7.09,2.54.28.84.19,1.54.44,2.09.77l-1.16,2.48c-1.06-.6-2.21-.89-3.47-.89-.75,0-1.3.1-1.68.31-.37.21-.56.48-.56.81,0,.37.2.63.6.78.4.15,1.04.29,1.92.42.98.16,1.79.34,2.42.53.63.19,1.17.53,1.63,1.02.46.49.69,1.18.69,2.06,0,.75-.22,1.41-.67,1.99-.45.58-1.1,1.03-1.96,1.35-.86.32-1.88.48-3.05.48-1,0-1.98-.12-2.93-.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M703.02,573.32h-7.27l-1.39,3.35h-3.71l6.98-15.66h3.58l7,15.66h-3.8l-1.39-3.35ZM701.88,570.56l-2.48-5.99-2.48,5.99h4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M709.84,561.01h7.11c1.7,0,3.2.32,4.51.97,1.3.65,2.32,1.56,3.04,2.74.72,1.18,1.08,2.55,1.08,4.11s-.36,2.94-1.08,4.12c-.72,1.18-1.74,2.09-3.04,2.74-1.3.65-2.81.97-4.51.97h-7.11v-15.66ZM716.77,573.7c1.57,0,2.81-.44,3.75-1.31s1.4-2.05,1.4-3.54-.47-2.67-1.4-3.54c-.93-.87-2.18-1.31-3.75-1.31h-3.31v9.71h3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M730.05,575.08c-1.25-1.24-1.87-3-1.87-5.3v-8.77h3.62v8.63c0,2.8,1.16,4.2,3.49,4.2,1.13,0,2-.34,2.59-1.02.6-.68.89-1.74.89-3.19v-8.63h3.58v8.77c0,2.3-.62,4.06-1.87,5.3-1.25,1.24-2.99,1.86-5.22,1.86s-3.98-.62-5.22-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M755.91,573.32h-7.27l-1.39,3.35h-3.71l6.98-15.66h3.58l7,15.66h-3.8l-1.39-3.35ZM754.77,570.56l-2.48-5.99-2.48,5.99h4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M777.09,561.01v15.66h-2.97l-7.8-9.5v9.5h-3.58v-15.66h3l7.78,9.5v-9.5h3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M791.11,573.32h-7.27l-1.39,3.35h-3.71l6.98-15.66h3.58l7,15.66h-3.8l-1.39-3.35ZM789.97,570.56l-2.48-5.99-2.48,5.99h4.96Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M878.15,561.01h7.11c1.7,0,3.2.32,4.51.97,1.3.65,2.32,1.56,3.04,2.74.72,1.18,1.08,2.55,1.08,4.11s-.36,2.94-1.08,4.12c-.72,1.18-1.74,2.09-3.04,2.74-1.3.65-2.81.97-4.51.97h-7.11v-15.66ZM885.09,573.7c1.57,0,2.81-.44,3.75-1.31s1.4-2.05,1.4-3.54-.47-2.67-1.4-3.54c-.93-.87-2.18-1.31-3.75-1.31h-3.31v9.71h3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M908.75,573.76v2.91h-12.12v-15.66h11.83v2.91h-8.23v3.4h7.27v2.82h-7.27v3.62h8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M913.19,576.43c-1.16-.34-2.08-.77-2.78-1.31l1.23-2.73c.67.49,1.47.89,2.39,1.19.92.3,1.85.45,2.77.45,1.03,0,1.79-.15,2.28-.46.49-.31.74-.71.74-1.22,0-.37-.15-.68-.44-.93-.29-.25-.66-.44-1.12-.59-.46-.15-1.07-.31-1.84-.49-1.19-.28-2.17-.57-2.93-.85-.76-.28-1.41-.74-1.96-1.36-.54-.63-.82-1.46-.82-2.5,0-.91.25-1.73.74-2.47.49-.74,1.23-1.32,2.22-1.76.99-.43,2.2-.65,3.63-.65,1,0,1.97.12,2.93.36.95.24,1.79.58,2.5,1.03l-1.12,2.75c-1.45-.82-2.89-1.23-4.34-1.23-1.01,0-1.76.16-2.25.49s-.73.76-.73,1.3.28.94.84,1.2c.56.26,1.41.52,2.56.77,1.19.28,2.17.57,2.93.85.76.28,1.41.73,1.96,1.34.54.61.82,1.44.82,2.48,0,.89-.25,1.71-.75,2.45-.5.74-1.25,1.32-2.25,1.76-1,.43-2.21.65-3.65.65-1.24,0-2.43-.17-3.59-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M928.92,563.97h-5.01v-2.95h13.64v2.95h-5.01v12.7h-3.62v-12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M939.5,561.01h3.62v15.66h-3.62v-15.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M961.19,561.01v15.66h-2.97l-7.8-9.5v9.5h-3.58v-15.66h3l7.78,9.5v-9.5h3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M968.09,575.89c-1.3-.7-2.33-1.67-3.06-2.9-.74-1.23-1.11-2.61-1.11-4.15s.37-2.92,1.11-4.15c.74-1.23,1.76-2.2,3.06-2.9,1.3-.7,2.77-1.05,4.39-1.05s3.09.35,4.38,1.05c1.3.7,2.32,1.67,3.06,2.9s1.12,2.61,1.12,4.15-.37,2.92-1.12,4.15c-.75,1.23-1.77,2.2-3.06,2.9-1.3.7-2.76,1.05-4.38,1.05s-3.09-.35-4.39-1.05ZM974.99,573.21c.75-.43,1.33-1.02,1.76-1.78.42-.76.64-1.62.64-2.59s-.21-1.83-.64-2.59-1.01-1.35-1.76-1.78-1.58-.64-2.5-.64-1.76.21-2.5.64c-.75.42-1.33,1.02-1.75,1.78-.43.76-.64,1.63-.64,2.59s.21,1.83.64,2.59c.42.76,1.01,1.35,1.75,1.78.75.42,1.58.64,2.5.64s1.76-.21,2.5-.64Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.9,437.42v12.59c0,3.19-2.59,5.78-5.78,5.78h-40.01c-3.19,0-5.78-2.59-5.78-5.78v-12.59"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 78.11,
    y1: 439.1,
    x2: 78.11,
    y2: 404.43
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "63.94 418.5 78.11 404.33 92.44 418.65"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M950.36,437.42v12.59c0,3.19-2.59,5.78-5.78,5.78h-40.01c-3.19,0-5.78-2.59-5.78-5.78v-12.59"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 924.57,
    y1: 404.33,
    x2: 924.57,
    y2: 439
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "938.75 424.93 924.57 439.1 910.25 424.77"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 90.63,
    y1: 311.05,
    x2: 90.63,
    y2: 331.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 102.36,
    y1: 311.05,
    x2: 102.36,
    y2: 331.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.09,
    y1: 311.05,
    x2: 114.09,
    y2: 331.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.82,
    y1: 311.05,
    x2: 125.82,
    y2: 331.4
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 81.64,
    y1: 343.26,
    x2: 134.81,
    y2: 343.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "108.22 286.21 84.98 300.14 131.47 300.14 108.22 286.21"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 875.5,
    y1: 311.22,
    x2: 875.5,
    y2: 331.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 887.23,
    y1: 311.22,
    x2: 887.23,
    y2: 331.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 898.96,
    y1: 311.22,
    x2: 898.96,
    y2: 331.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 910.69,
    y1: 311.22,
    x2: 910.69,
    y2: 331.58
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 866.51,
    y1: 343.43,
    x2: 919.68,
    y2: 343.43
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "893.1 286.39 869.85 300.31 916.34 300.31 893.1 286.39"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 188.96,
    y1: 221.34,
    x2: 174.17,
    y2: 221.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163.21,221.34h-4.69c-1.64,0-2.98-1.33-2.98-2.98v-30.44c0-1.64,1.33-2.98,2.98-2.98h25.42c1.63,0,2.96,1.32,2.98,2.95l.06,7.36,9.36.08c.67,0,1.3.31,1.72.82l3.99,4.88,4.96,6.18c.43.54.67,1.21.67,1.91v9.25c0,1.64-1.33,2.98-2.98,2.98h-4.81"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 186.98,
    y1: 195.25,
    x2: 186.98,
    y2: 221.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 168.72,
    cy: 221.27,
    r: 5.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 194.48,
    cy: 221.27,
    r: 5.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.22,
    y1: 92.43,
    x2: 563.43,
    y2: 92.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M552.47,92.43h-4.69c-1.64,0-2.98-1.33-2.98-2.98v-30.44c0-1.64,1.33-2.98,2.98-2.98h25.42c1.63,0,2.96,1.32,2.98,2.95l.06,7.36,9.36.08c.67,0,1.3.31,1.72.82l3.99,4.88,4.96,6.18c.43.54.67,1.21.67,1.91v9.25c0,1.64-1.33,2.98-2.98,2.98h-4.81"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 576.24,
    y1: 66.35,
    x2: 576.24,
    y2: 92.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 557.98,
    cy: 92.37,
    r: 5.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 583.74,
    cy: 92.37,
    r: 5.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 830.15,
    y1: 221.6,
    x2: 815.36,
    y2: 221.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M804.39,221.6h-4.69c-1.64,0-2.98-1.33-2.98-2.98v-30.44c0-1.64,1.33-2.98,2.98-2.98h25.42c1.63,0,2.96,1.32,2.98,2.95l.06,7.36,9.36.08c.67,0,1.3.31,1.72.82l3.99,4.88,4.96,6.18c.43.54.67,1.21.67,1.91v9.25c0,1.64-1.33,2.98-2.98,2.98h-4.81"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 828.16,
    y1: 195.51,
    x2: 828.16,
    y2: 221.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 809.9,
    cy: 221.53,
    r: 5.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 835.66,
    cy: 221.53,
    r: 5.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 299.61,
    cy: 94.69,
    r: 12.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327.81,120.69c0,2.14-.89,4.06-2.33,5.43-1.35,1.28-3.17,2.07-5.18,2.07-4.14,0-7.5-3.36-7.5-7.5s3.36-7.5,7.5-7.5,7.5,3.36,7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.17,129.1s-.65-24.25,26.32-21.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 330.78,
    y1: 131.24,
    x2: 325.48,
    y2: 126.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.17,129.1s-.67-24.05,26.32-21.02"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 693.29,
    cy: 94.69,
    r: 12.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M721.49,120.69c0,2.14-.89,4.06-2.33,5.43-1.35,1.28-3.17,2.07-5.18,2.07-4.14,0-7.5-3.36-7.5-7.5s3.36-7.5,7.5-7.5,7.5,3.36,7.5,7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M672.85,129.1s-.65-24.25,26.32-21.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 724.46,
    y1: 131.24,
    x2: 719.16,
    y2: 126.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M672.85,129.1s-.67-24.05,26.32-21.02"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M422.26,71.68v-12.59c0-3.19,1.79-5.78,3.99-5.78h27.63c2.2,0,3.99,2.59,3.99,5.78v12.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "463.54 76.72 440.06 66.11 416.59 76.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M423.31,94.96s-5.17-4.79-6.73-18.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M459.57,91.5c1.5-3.09,3.19-7.88,3.98-14.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 440.06,
    y1: 45.29,
    x2: 440.06,
    y2: 52.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 440.06,
    y1: 67.92,
    x2: 440.06,
    y2: 76.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M413.51,93.92c2.57,2.84,7.02,3.78,10.51,2.21,2.8-1.26,5.01-3.93,8.06-4.31,2.68-.33,5.2,1.22,7.46,2.71,2.26,1.49,4.78,3.03,7.46,2.69,3.25-.42,5.49-3.43,8.48-4.76,3.26-1.45,9.93-.02,12.78,3.69"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1004.48,503.74h-149.7c0-193.57-157.48-351.04-351.04-351.04S152.7,310.17,152.7,503.74H3c0-67.57,13.25-133.15,39.38-194.93,25.22-59.64,61.32-113.18,107.28-159.14,45.96-45.96,99.51-82.06,159.14-107.28C370.59,16.25,436.17,3,503.74,3s133.15,13.25,194.93,39.38c59.64,25.22,113.18,61.32,159.14,107.28,45.96,45.96,82.06,99.51,107.28,159.14,26.13,61.78,39.38,127.37,39.38,194.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M40.39,477.28v1.51h-6.32v-8.16h6.17v1.51h-4.29v1.77h3.79v1.47h-3.79v1.89h4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M46.95,478.8l-1.97-2.83-1.93,2.83h-2.17l3.02-4.15-2.87-4.01h2.14l1.88,2.65,1.84-2.65h2.04l-2.84,3.94,3.04,4.22h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M55.29,471c.53.24.94.58,1.23,1.03.29.44.43.97.43,1.57s-.14,1.12-.43,1.57c-.29.45-.7.79-1.23,1.03-.53.24-1.16.36-1.88.36h-1.64v2.25h-1.89v-8.16h3.53c.72,0,1.35.12,1.88.36ZM54.6,474.64c.29-.25.44-.59.44-1.04s-.15-.81-.44-1.05c-.29-.24-.73-.37-1.29-.37h-1.54v2.83h1.54c.57,0,1-.12,1.29-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M60.07,478.39c-.68-.36-1.21-.87-1.6-1.51s-.58-1.36-.58-2.16.19-1.52.58-2.16.92-1.14,1.6-1.51,1.44-.55,2.29-.55,1.61.18,2.28.55,1.21.87,1.6,1.51.58,1.36.58,2.16-.19,1.52-.58,2.16-.92,1.14-1.6,1.51c-.68.37-1.44.55-2.28.55s-1.61-.18-2.29-.55ZM63.66,476.99c.39-.22.69-.53.92-.93.22-.4.33-.85.33-1.35s-.11-.96-.33-1.35c-.22-.4-.53-.7-.92-.93s-.82-.33-1.3-.33-.92.11-1.31.33-.69.53-.92.93c-.22.4-.33.85-.33,1.35s.11.96.33,1.35c.22.4.53.71.92.93.39.22.82.33,1.31.33s.92-.11,1.3-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73.44,478.8l-1.57-2.27h-1.74v2.27h-1.89v-8.16h3.53c.72,0,1.35.12,1.88.36.53.24.94.58,1.23,1.03.29.44.43.97.43,1.57s-.15,1.13-.44,1.57c-.29.44-.71.78-1.24,1.01l1.83,2.62h-2.03ZM72.96,472.54c-.29-.24-.73-.37-1.29-.37h-1.54v2.84h1.54c.57,0,1-.12,1.29-.37.29-.25.44-.6.44-1.05s-.15-.81-.44-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M78.38,472.18h-2.61v-1.54h7.11v1.54h-2.61v6.62h-1.89v-6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M88.86,477.05h-3.79l-.72,1.75h-1.93l3.64-8.16h1.86l3.65,8.16h-1.98l-.72-1.75ZM88.26,475.61l-1.29-3.12-1.29,3.12h2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M92.41,470.64h3.71c.89,0,1.67.17,2.35.51s1.21.81,1.58,1.43c.38.61.57,1.33.57,2.14s-.19,1.53-.57,2.14c-.38.61-.91,1.09-1.58,1.43s-1.46.51-2.35.51h-3.71v-8.16ZM96.02,477.25c.82,0,1.47-.23,1.95-.68s.73-1.07.73-1.85-.24-1.39-.73-1.85c-.49-.45-1.14-.68-1.95-.68h-1.72v5.06h1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M103.7,478.39c-.68-.36-1.21-.87-1.6-1.51s-.58-1.36-.58-2.16.19-1.52.58-2.16.92-1.14,1.6-1.51,1.44-.55,2.29-.55,1.61.18,2.28.55,1.21.87,1.6,1.51.58,1.36.58,2.16-.19,1.52-.58,2.16-.92,1.14-1.6,1.51c-.68.37-1.44.55-2.28.55s-1.61-.18-2.29-.55ZM107.29,476.99c.39-.22.69-.53.92-.93.22-.4.33-.85.33-1.35s-.11-.96-.33-1.35c-.22-.4-.53-.7-.92-.93s-.82-.33-1.3-.33-.92.11-1.31.33-.69.53-.92.93c-.22.4-.33.85-.33,1.35s.11.96.33,1.35c.22.4.53.71.92.93.39.22.82.33,1.31.33s.92-.11,1.3-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M117.07,478.8l-1.57-2.27h-1.74v2.27h-1.89v-8.16h3.53c.72,0,1.35.12,1.88.36.53.24.94.58,1.23,1.03.29.44.43.97.43,1.57s-.15,1.13-.44,1.57c-.29.44-.71.78-1.24,1.01l1.83,2.62h-2.03ZM116.59,472.54c-.29-.24-.73-.37-1.29-.37h-1.54v2.84h1.54c.57,0,1-.12,1.29-.37.29-.25.44-.6.44-1.05s-.15-.81-.44-1.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M884.17,470.78h1.89v8.16h-1.89v-8.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M895.41,478.93v-4.89s-2.41,4.03-2.41,4.03h-.85l-2.39-3.93v4.79h-1.77v-8.16h1.56l3.05,5.07,3.01-5.07h1.55l.02,8.16h-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M904.53,471.14c.53.24.94.58,1.23,1.03.29.44.43.97.43,1.57s-.14,1.12-.43,1.57c-.29.45-.7.79-1.23,1.03-.53.24-1.16.36-1.88.36h-1.64v2.25h-1.89v-8.16h3.53c.72,0,1.35.12,1.88.36ZM903.84,474.78c.29-.25.44-.59.44-1.04s-.15-.81-.44-1.05c-.29-.24-.73-.37-1.29-.37h-1.54v2.83h1.54c.57,0,1-.12,1.29-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M909.31,478.53c-.68-.36-1.21-.87-1.6-1.51s-.58-1.36-.58-2.16.19-1.52.58-2.16.92-1.14,1.6-1.51,1.44-.55,2.29-.55,1.61.18,2.28.55,1.21.87,1.6,1.51.58,1.36.58,2.16-.19,1.52-.58,2.16-.92,1.14-1.6,1.51c-.68.37-1.44.55-2.28.55s-1.61-.18-2.29-.55ZM912.9,477.13c.39-.22.69-.53.92-.93.22-.4.33-.85.33-1.35s-.11-.96-.33-1.35c-.22-.4-.53-.7-.92-.93s-.82-.33-1.3-.33-.92.11-1.31.33-.69.53-.92.93c-.22.4-.33.85-.33,1.35s.11.96.33,1.35c.22.4.53.71.92.93.39.22.82.33,1.31.33s.92-.11,1.3-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M922.68,478.93l-1.57-2.27h-1.74v2.27h-1.89v-8.16h3.53c.72,0,1.35.12,1.88.36.53.24.94.58,1.23,1.03.29.44.43.97.43,1.57s-.15,1.13-.44,1.57c-.29.44-.71.78-1.24,1.01l1.83,2.62h-2.03ZM922.2,472.68c-.29-.24-.73-.37-1.29-.37h-1.54v2.84h1.54c.57,0,1-.12,1.29-.37.29-.25.44-.6.44-1.05s-.15-.81-.44-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M927.62,472.32h-2.61v-1.54h7.11v1.54h-2.61v6.62h-1.89v-6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M938.1,477.19h-3.79l-.72,1.75h-1.93l3.64-8.16h1.86l3.65,8.16h-1.98l-.72-1.75ZM937.5,475.75l-1.29-3.12-1.29,3.12h2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M941.65,470.78h3.71c.89,0,1.67.17,2.35.51s1.21.81,1.58,1.43c.38.61.57,1.33.57,2.14s-.19,1.53-.57,2.14c-.38.61-.91,1.09-1.58,1.43s-1.46.51-2.35.51h-3.71v-8.16ZM945.26,477.39c.82,0,1.47-.23,1.95-.68s.73-1.07.73-1.85-.24-1.39-.73-1.85c-.49-.45-1.14-.68-1.95-.68h-1.72v5.06h1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M952.94,478.53c-.68-.36-1.21-.87-1.6-1.51s-.58-1.36-.58-2.16.19-1.52.58-2.16.92-1.14,1.6-1.51,1.44-.55,2.29-.55,1.61.18,2.28.55,1.21.87,1.6,1.51.58,1.36.58,2.16-.19,1.52-.58,2.16-.92,1.14-1.6,1.51c-.68.37-1.44.55-2.28.55s-1.61-.18-2.29-.55ZM956.53,477.13c.39-.22.69-.53.92-.93.22-.4.33-.85.33-1.35s-.11-.96-.33-1.35c-.22-.4-.53-.7-.92-.93s-.82-.33-1.3-.33-.92.11-1.31.33-.69.53-.92.93c-.22.4-.33.85-.33,1.35s.11.96.33,1.35c.22.4.53.71.92.93.39.22.82.33,1.31.33s.92-.11,1.3-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M966.31,478.93l-1.57-2.27h-1.74v2.27h-1.89v-8.16h3.53c.72,0,1.35.12,1.88.36.53.24.94.58,1.23,1.03.29.44.43.97.43,1.57s-.15,1.13-.44,1.57c-.29.44-.71.78-1.24,1.01l1.83,2.62h-2.03ZM965.83,472.68c-.29-.24-.73-.37-1.29-.37h-1.54v2.84h1.54c.57,0,1-.12,1.29-.37.29-.25.44-.6.44-1.05s-.15-.81-.44-1.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.31,363.79c.26.35.4.77.4,1.28,0,.71-.28,1.26-.83,1.65-.56.38-1.37.58-2.43.58h-4.22v-8.16h3.99c.99,0,1.76.19,2.29.57s.8.9.8,1.55c0,.4-.09.75-.29,1.06s-.46.56-.8.73c.47.15.83.39,1.09.74ZM89.1,360.55v1.92h1.88c.47,0,.82-.08,1.06-.25.24-.16.36-.4.36-.72s-.12-.56-.36-.72c-.24-.16-.59-.24-1.06-.24h-1.88ZM92.43,365.62c.25-.16.38-.42.38-.76,0-.68-.5-1.01-1.5-1.01h-2.2v2.02h2.2c.5,0,.87-.08,1.12-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M101.51,365.54h-3.79l-.72,1.75h-1.93l3.64-8.16h1.86l3.65,8.16h-1.98l-.72-1.75ZM100.92,364.11l-1.29-3.12-1.29,3.12h2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M112.55,359.13v8.16h-1.55l-4.07-4.95v4.95h-1.87v-8.16h1.56l4.06,4.95v-4.95h1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M116.13,366.89c-.67-.36-1.2-.86-1.58-1.5s-.58-1.37-.58-2.17.19-1.53.58-2.17c.38-.64.91-1.14,1.58-1.5s1.43-.54,2.27-.54c.71,0,1.35.12,1.92.37.57.25,1.05.61,1.44,1.07l-1.21,1.12c-.55-.64-1.24-.96-2.05-.96-.5,0-.96.11-1.35.33s-.71.53-.93.93c-.22.4-.33.85-.33,1.35s.11.96.33,1.35c.22.4.53.71.93.93.4.22.85.33,1.35.33.82,0,1.5-.32,2.05-.97l1.21,1.12c-.39.47-.87.83-1.44,1.08-.58.25-1.22.37-1.92.37-.83,0-1.58-.18-2.25-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M124.51,366.88c-.68-.36-1.21-.87-1.6-1.51s-.58-1.36-.58-2.16.19-1.52.58-2.16.92-1.14,1.6-1.51,1.44-.55,2.29-.55,1.61.18,2.28.55,1.21.87,1.6,1.51.58,1.36.58,2.16-.19,1.52-.58,2.16-.92,1.14-1.6,1.51c-.68.37-1.44.55-2.28.55s-1.61-.18-2.29-.55ZM128.1,365.49c.39-.22.69-.53.92-.93.22-.4.33-.85.33-1.35s-.11-.96-.33-1.35c-.22-.4-.53-.7-.92-.93s-.82-.33-1.3-.33-.92.11-1.31.33-.69.53-.92.93c-.22.4-.33.85-.33,1.35s.11.96.33,1.35c.22.4.53.71.92.93.39.22.82.33,1.31.33s.92-.11,1.3-.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M879.56,363.79c.26.35.4.77.4,1.28,0,.71-.28,1.26-.83,1.65-.56.38-1.37.58-2.43.58h-4.22v-8.16h3.99c.99,0,1.76.19,2.29.57s.8.9.8,1.55c0,.4-.09.75-.29,1.06s-.46.56-.8.73c.47.15.83.39,1.09.74ZM874.35,360.55v1.92h1.88c.47,0,.82-.08,1.06-.25.24-.16.36-.4.36-.72s-.12-.56-.36-.72c-.24-.16-.59-.24-1.06-.24h-1.88ZM877.67,365.62c.25-.16.38-.42.38-.76,0-.68-.5-1.01-1.5-1.01h-2.2v2.02h2.2c.5,0,.87-.08,1.12-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M886.76,365.54h-3.79l-.72,1.75h-1.93l3.64-8.16h1.86l3.65,8.16h-1.98l-.72-1.75ZM886.16,364.11l-1.29-3.12-1.29,3.12h2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M897.79,359.13v8.16h-1.55l-4.07-4.95v4.95h-1.87v-8.16h1.56l4.06,4.95v-4.95h1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M901.38,366.89c-.67-.36-1.2-.86-1.58-1.5s-.58-1.37-.58-2.17.19-1.53.58-2.17c.38-.64.91-1.14,1.58-1.5s1.43-.54,2.27-.54c.71,0,1.35.12,1.92.37.57.25,1.05.61,1.44,1.07l-1.21,1.12c-.55-.64-1.24-.96-2.05-.96-.5,0-.96.11-1.35.33s-.71.53-.93.93c-.22.4-.33.85-.33,1.35s.11.96.33,1.35c.22.4.53.71.93.93.4.22.85.33,1.35.33.82,0,1.5-.32,2.05-.97l1.21,1.12c-.39.47-.87.83-1.44,1.08-.58.25-1.22.37-1.92.37-.83,0-1.58-.18-2.25-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M909.75,366.88c-.68-.36-1.21-.87-1.6-1.51s-.58-1.36-.58-2.16.19-1.52.58-2.16.92-1.14,1.6-1.51,1.44-.55,2.29-.55,1.61.18,2.28.55,1.21.87,1.6,1.51.58,1.36.58,2.16-.19,1.52-.58,2.16-.92,1.14-1.6,1.51c-.68.37-1.44.55-2.28.55s-1.61-.18-2.29-.55ZM913.35,365.49c.39-.22.69-.53.92-.93.22-.4.33-.85.33-1.35s-.11-.96-.33-1.35c-.22-.4-.53-.7-.92-.93s-.82-.33-1.3-.33-.92.11-1.31.33-.69.53-.92.93c-.22.4-.33.85-.33,1.35s.11.96.33,1.35c.22.4.53.71.92.93.39.22.82.33,1.31.33s.92-.11,1.3-.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M132.43,244.06h-2.61v-1.54h7.11v1.54h-2.61v6.62h-1.89v-6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M143.13,250.68l-1.57-2.27h-1.74v2.27h-1.89v-8.16h3.53c.72,0,1.35.12,1.88.36.53.24.94.58,1.23,1.03.29.44.43.97.43,1.57s-.15,1.13-.44,1.57c-.29.44-.71.78-1.24,1.01l1.83,2.62h-2.03ZM142.66,244.43c-.29-.24-.73-.37-1.29-.37h-1.54v2.84h1.54c.57,0,1-.12,1.29-.37.29-.25.44-.6.44-1.05s-.15-.81-.44-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M151.87,248.93h-3.79l-.72,1.75h-1.93l3.64-8.16h1.86l3.65,8.16h-1.98l-.72-1.75ZM151.28,247.5l-1.29-3.12-1.29,3.12h2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M162.91,242.53v8.16h-1.55l-4.07-4.95v4.95h-1.87v-8.16h1.56l4.06,4.95v-4.95h1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M165.65,250.56c-.6-.17-1.09-.4-1.45-.68l.64-1.42c.35.26.77.46,1.25.62.48.16.96.23,1.45.23.54,0,.93-.08,1.19-.24.26-.16.38-.37.38-.63,0-.19-.08-.36-.23-.48s-.35-.23-.58-.31c-.24-.08-.56-.16-.96-.26-.62-.15-1.13-.29-1.53-.44-.4-.15-.74-.38-1.02-.71-.28-.33-.43-.76-.43-1.31,0-.47.13-.9.38-1.29.26-.38.64-.69,1.16-.92s1.15-.34,1.89-.34c.52,0,1.03.06,1.53.19s.93.3,1.31.54l-.58,1.43c-.75-.43-1.51-.64-2.26-.64-.53,0-.92.09-1.17.26-.25.17-.38.4-.38.68s.15.49.44.62c.29.14.74.27,1.33.4.62.15,1.13.29,1.53.44.4.15.74.38,1.02.7.28.32.43.75.43,1.29,0,.47-.13.89-.39,1.28-.26.38-.65.69-1.17.92-.52.23-1.15.34-1.9.34-.65,0-1.27-.09-1.87-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M177.69,242.89c.53.24.94.58,1.23,1.03.29.44.43.97.43,1.57s-.14,1.12-.43,1.57c-.29.45-.7.79-1.23,1.03-.53.24-1.16.36-1.88.36h-1.64v2.25h-1.89v-8.16h3.53c.72,0,1.35.12,1.88.36ZM177,246.53c.29-.25.44-.59.44-1.04s-.15-.81-.44-1.05c-.29-.24-.73-.37-1.29-.37h-1.54v2.83h1.54c.57,0,1-.12,1.29-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M182.47,250.27c-.68-.36-1.21-.87-1.6-1.51s-.58-1.36-.58-2.16.19-1.52.58-2.16.92-1.14,1.6-1.51,1.44-.55,2.29-.55,1.61.18,2.28.55,1.21.87,1.6,1.51.58,1.36.58,2.16-.19,1.52-.58,2.16-.92,1.14-1.6,1.51c-.68.37-1.44.55-2.28.55s-1.61-.18-2.29-.55ZM186.06,248.88c.39-.22.69-.53.92-.93.22-.4.33-.85.33-1.35s-.11-.96-.33-1.35c-.22-.4-.53-.7-.92-.93s-.82-.33-1.3-.33-.92.11-1.31.33-.69.53-.92.93c-.22.4-.33.85-.33,1.35s.11.96.33,1.35c.22.4.53.71.92.93.39.22.82.33,1.31.33s.92-.11,1.3-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M195.84,250.68l-1.57-2.27h-1.74v2.27h-1.89v-8.16h3.53c.72,0,1.35.12,1.88.36.53.24.94.58,1.23,1.03.29.44.43.97.43,1.57s-.15,1.13-.44,1.57c-.29.44-.71.78-1.24,1.01l1.83,2.62h-2.03ZM195.36,244.43c-.29-.24-.73-.37-1.29-.37h-1.54v2.84h1.54c.57,0,1-.12,1.29-.37.29-.25.44-.6.44-1.05s-.15-.81-.44-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M200.78,244.06h-2.61v-1.54h7.11v1.54h-2.61v6.62h-1.89v-6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M206.29,242.53h1.89v8.16h-1.89v-8.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M210.92,250.56c-.6-.17-1.09-.4-1.45-.68l.64-1.42c.35.26.77.46,1.25.62.48.16.96.23,1.45.23.54,0,.93-.08,1.19-.24.26-.16.38-.37.38-.63,0-.19-.08-.36-.23-.48s-.35-.23-.58-.31c-.24-.08-.56-.16-.96-.26-.62-.15-1.13-.29-1.53-.44-.4-.15-.74-.38-1.02-.71-.28-.33-.43-.76-.43-1.31,0-.47.13-.9.38-1.29.26-.38.64-.69,1.16-.92s1.15-.34,1.89-.34c.52,0,1.03.06,1.53.19s.93.3,1.31.54l-.58,1.43c-.75-.43-1.51-.64-2.26-.64-.53,0-.92.09-1.17.26-.25.17-.38.4-.38.68s.15.49.44.62c.29.14.74.27,1.33.4.62.15,1.13.29,1.53.44.4.15.74.38,1.02.7.28.32.43.75.43,1.29,0,.47-.13.89-.39,1.28-.26.38-.65.69-1.17.92-.52.23-1.15.34-1.9.34-.65,0-1.27-.09-1.87-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M219.12,244.06h-2.61v-1.54h7.11v1.54h-2.61v6.62h-1.89v-6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M229.6,248.93h-3.79l-.72,1.75h-1.93l3.64-8.16h1.86l3.65,8.16h-1.98l-.72-1.75ZM229,247.5l-1.29-3.12-1.29,3.12h2.59Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M252.21,151.34h-3.67l-.7,1.7h-1.88l3.53-7.91h1.81l3.54,7.91h-1.92l-.7-1.7ZM251.63,149.95l-1.25-3.03-1.25,3.03h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M260.89,148.95h1.67v3.21c-.43.32-.93.57-1.49.75-.56.17-1.13.26-1.71.26-.82,0-1.56-.18-2.22-.53-.66-.35-1.17-.84-1.54-1.46s-.56-1.32-.56-2.11.19-1.49.56-2.11.89-1.11,1.55-1.46,1.41-.53,2.24-.53c.69,0,1.32.12,1.89.35.57.23,1.04.57,1.42,1.02l-1.18,1.08c-.57-.6-1.25-.89-2.05-.89-.5,0-.95.11-1.34.32-.39.21-.7.51-.92.89s-.33.83-.33,1.32.11.93.33,1.31.52.68.91.9c.39.21.83.32,1.33.32.53,0,1-.11,1.42-.34v-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M270.38,151.56v1.47h-6.13v-7.91h5.98v1.47h-4.16v1.72h3.67v1.42h-3.67v1.83h4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M279.1,145.12v7.91h-1.5l-3.95-4.8v4.8h-1.81v-7.91h1.51l3.93,4.8v-4.8h1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M282.61,146.61h-2.53v-1.49h6.89v1.49h-2.53v6.42h-1.83v-6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M294.08,151.56v1.47h-6.13v-7.91h5.98v1.47h-4.16v1.72h3.67v1.42h-3.67v1.83h4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M303.95,151.34h-3.67l-.7,1.7h-1.88l3.53-7.91h1.81l3.54,7.91h-1.92l-.7-1.7ZM303.37,149.95l-1.25-3.03-1.25,3.03h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M307.4,145.12h3.59c.86,0,1.62.16,2.28.49.66.33,1.17.79,1.54,1.38.37.6.55,1.29.55,2.08s-.18,1.48-.55,2.08c-.37.6-.88,1.06-1.54,1.38s-1.42.49-2.28.49h-3.59v-7.91ZM310.9,151.53c.79,0,1.42-.22,1.89-.66s.71-1.04.71-1.79-.24-1.35-.71-1.79-1.1-.66-1.89-.66h-1.67v4.91h1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M317.61,152.23c-.63-.62-.94-1.52-.94-2.68v-4.43h1.83v4.36c0,1.42.59,2.12,1.76,2.12.57,0,1.01-.17,1.31-.51.3-.34.45-.88.45-1.61v-4.36h1.81v4.43c0,1.16-.31,2.05-.94,2.68-.63.63-1.51.94-2.64.94s-2.01-.31-2.64-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M330.68,151.34h-3.67l-.7,1.7h-1.88l3.53-7.91h1.81l3.54,7.91h-1.92l-.7-1.7ZM330.1,149.95l-1.25-3.03-1.25,3.03h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M341.38,145.12v7.91h-1.5l-3.95-4.8v4.8h-1.81v-7.91h1.51l3.93,4.8v-4.8h1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M348.47,151.34h-3.67l-.7,1.7h-1.88l3.53-7.91h1.81l3.54,7.91h-1.92l-.7-1.7ZM347.9,149.95l-1.25-3.03-1.25,3.03h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M351.92,145.12h1.83v6.42h3.97v1.49h-5.8v-7.91Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M437.33,123.62v1.47h-6.13v-7.91h5.98v1.47h-4.16v1.72h3.67v1.42h-3.67v1.83h4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M446.04,117.18v7.91h-1.5l-3.95-4.8v4.8h-1.81v-7.91h1.51l3.93,4.8v-4.8h1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M455.48,117.18l-3.42,7.91h-1.81l-3.41-7.91h1.98l2.41,5.65,2.44-5.65h1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M457.55,114.9h1.9l-2.05,1.63h-1.38l1.53-1.63ZM456.14,117.18h1.83v7.91h-1.83v-7.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M461.46,124.69c-.66-.35-1.18-.84-1.55-1.46s-.56-1.32-.56-2.1.19-1.48.56-2.1.89-1.11,1.55-1.46c.66-.35,1.4-.53,2.22-.53s1.56.18,2.22.53c.66.35,1.17.84,1.55,1.46s.57,1.32.57,2.1-.19,1.48-.57,2.1-.89,1.11-1.55,1.46c-.66.35-1.39.53-2.22.53s-1.56-.18-2.22-.53ZM464.94,123.34c.38-.21.67-.51.89-.9s.32-.82.32-1.31-.11-.93-.32-1.31-.51-.68-.89-.9c-.38-.21-.8-.32-1.27-.32s-.89.11-1.27.32-.67.51-.89.9-.32.82-.32,1.31.11.93.32,1.31.51.68.89.9c.38.21.8.32,1.27.32s.89-.11,1.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M472.58,117.18h1.83v7.91h-1.83v-7.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M483.55,117.18v7.91h-1.5l-3.95-4.8v4.8h-1.81v-7.91h1.51l3.93,4.8v-4.8h1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M487.06,118.67h-2.53v-1.49h6.89v1.49h-2.53v6.42h-1.83v-6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M498.53,123.62v1.47h-6.13v-7.91h5.98v1.47h-4.16v1.72h3.67v1.42h-3.67v1.83h4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M505.03,125.09l-1.53-2.2h-1.68v2.2h-1.83v-7.91h3.42c.7,0,1.31.12,1.83.35.52.23.91.56,1.19.99.28.43.42.94.42,1.53s-.14,1.09-.42,1.52c-.28.43-.68.75-1.2.98l1.78,2.54h-1.97ZM504.57,119.02c-.29-.24-.7-.36-1.25-.36h-1.49v2.76h1.49c.55,0,.97-.12,1.25-.36.29-.24.43-.58.43-1.02s-.14-.79-.43-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M515.56,117.18v7.91h-1.5l-3.95-4.8v4.8h-1.81v-7.91h1.51l3.93,4.8v-4.8h1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M522.64,123.39h-3.67l-.7,1.7h-1.88l3.53-7.91h1.81l3.54,7.91h-1.92l-.7-1.7ZM522.07,122l-1.25-3.03-1.25,3.03h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M527.58,124.7c-.65-.35-1.16-.84-1.54-1.46s-.56-1.32-.56-2.11.19-1.49.56-2.11.89-1.11,1.54-1.46c.65-.35,1.38-.53,2.2-.53.69,0,1.3.12,1.86.36.55.24,1.02.59,1.4,1.04l-1.18,1.08c-.54-.62-1.2-.93-1.99-.93-.49,0-.93.11-1.31.32-.38.21-.68.51-.9.9s-.32.82-.32,1.31.11.93.32,1.31.51.68.9.9c.38.21.82.32,1.31.32.79,0,1.45-.31,1.99-.94l1.18,1.08c-.38.46-.84.81-1.4,1.05s-1.18.36-1.87.36c-.81,0-1.54-.18-2.19-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M534.26,117.18h1.83v7.91h-1.83v-7.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M539.58,124.69c-.66-.35-1.18-.84-1.55-1.46s-.56-1.32-.56-2.1.19-1.48.56-2.1.89-1.11,1.55-1.46c.66-.35,1.4-.53,2.22-.53s1.56.18,2.22.53c.66.35,1.17.84,1.55,1.46s.57,1.32.57,2.1-.19,1.48-.57,2.1-.89,1.11-1.55,1.46c-.66.35-1.39.53-2.22.53s-1.56-.18-2.22-.53ZM543.07,123.34c.38-.21.67-.51.89-.9s.32-.82.32-1.31-.11-.93-.32-1.31-.51-.68-.89-.9c-.38-.21-.8-.32-1.27-.32s-.89.11-1.27.32-.67.51-.89.9-.32.82-.32,1.31.11.93.32,1.31.51.68.89.9c.38.21.8.32,1.27.32s.89-.11,1.27-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M554.76,117.18v7.91h-1.5l-3.95-4.8v4.8h-1.81v-7.91h1.51l3.93,4.8v-4.8h1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M561.85,123.39h-3.67l-.7,1.7h-1.88l3.53-7.91h1.81l3.54,7.91h-1.92l-.7-1.7ZM561.28,122l-1.25-3.03-1.25,3.03h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M565.3,117.18h1.83v6.42h3.97v1.49h-5.8v-7.91Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M652.21,151.47h-3.67l-.7,1.7h-1.88l3.53-7.91h1.81l3.54,7.91h-1.92l-.7-1.7ZM651.63,150.08l-1.25-3.03-1.25,3.03h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M660.89,149.09h1.67v3.21c-.43.32-.93.57-1.49.75-.56.17-1.13.26-1.71.26-.82,0-1.56-.18-2.22-.53-.66-.35-1.17-.84-1.54-1.46s-.56-1.32-.56-2.11.19-1.49.56-2.11.89-1.11,1.55-1.46,1.41-.53,2.24-.53c.69,0,1.32.12,1.89.35.57.23,1.04.57,1.42,1.02l-1.18,1.08c-.57-.6-1.25-.89-2.05-.89-.5,0-.95.11-1.34.32-.39.21-.7.51-.92.89s-.33.83-.33,1.32.11.93.33,1.31.52.68.91.9c.39.21.83.32,1.33.32.53,0,1-.11,1.42-.34v-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M670.38,151.7v1.47h-6.13v-7.91h5.98v1.47h-4.16v1.72h3.67v1.42h-3.67v1.83h4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M679.1,145.26v7.91h-1.5l-3.95-4.8v4.8h-1.81v-7.91h1.51l3.93,4.8v-4.8h1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M682.61,146.75h-2.53v-1.49h6.89v1.49h-2.53v6.42h-1.83v-6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M694.08,151.7v1.47h-6.13v-7.91h5.98v1.47h-4.16v1.72h3.67v1.42h-3.67v1.83h4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M703.95,151.47h-3.67l-.7,1.7h-1.88l3.53-7.91h1.81l3.54,7.91h-1.92l-.7-1.7ZM703.37,150.08l-1.25-3.03-1.25,3.03h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M707.4,145.26h3.59c.86,0,1.62.16,2.28.49.66.33,1.17.79,1.54,1.38.37.6.55,1.29.55,2.08s-.18,1.48-.55,2.08c-.37.6-.88,1.06-1.54,1.38s-1.42.49-2.28.49h-3.59v-7.91ZM710.9,151.66c.79,0,1.42-.22,1.89-.66s.71-1.04.71-1.79-.24-1.35-.71-1.79-1.1-.66-1.89-.66h-1.67v4.91h1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M717.61,152.36c-.63-.62-.94-1.52-.94-2.68v-4.43h1.83v4.36c0,1.42.59,2.12,1.76,2.12.57,0,1.01-.17,1.31-.51.3-.34.45-.88.45-1.61v-4.36h1.81v4.43c0,1.16-.31,2.05-.94,2.68-.63.63-1.51.94-2.64.94s-2.01-.31-2.64-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M730.68,151.47h-3.67l-.7,1.7h-1.88l3.53-7.91h1.81l3.54,7.91h-1.92l-.7-1.7ZM730.1,150.08l-1.25-3.03-1.25,3.03h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M741.38,145.26v7.91h-1.5l-3.95-4.8v4.8h-1.81v-7.91h1.51l3.93,4.8v-4.8h1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M748.47,151.47h-3.67l-.7,1.7h-1.88l3.53-7.91h1.81l3.54,7.91h-1.92l-.7-1.7ZM747.9,150.08l-1.25-3.03-1.25,3.03h2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M751.92,145.26h1.83v6.42h3.97v1.49h-5.8v-7.91Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M776.35,244.65h-2.59v-1.53h7.05v1.53h-2.59v6.57h-1.87v-6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M786.98,251.22l-1.56-2.25h-1.72v2.25h-1.87v-8.1h3.5c.72,0,1.34.12,1.87.36.53.24.93.58,1.22,1.02s.43.96.43,1.56-.14,1.12-.43,1.56-.7.77-1.23,1l1.82,2.6h-2.01ZM786.51,245.01c-.29-.24-.72-.36-1.28-.36h-1.53v2.82h1.53c.56,0,.99-.12,1.28-.37.29-.25.44-.59.44-1.04s-.15-.8-.44-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M795.65,249.48h-3.76l-.72,1.73h-1.92l3.61-8.1h1.85l3.62,8.1h-1.97l-.72-1.73ZM795.06,248.06l-1.28-3.1-1.28,3.1h2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M806.61,243.12v8.1h-1.54l-4.04-4.92v4.92h-1.85v-8.1h1.55l4.02,4.92v-4.92h1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M809.33,251.1c-.6-.17-1.08-.4-1.44-.68l.64-1.41c.35.25.76.46,1.24.61.48.15.96.23,1.43.23.53,0,.93-.08,1.18-.24.25-.16.38-.37.38-.63,0-.19-.08-.35-.23-.48s-.34-.23-.58-.31-.55-.16-.95-.25c-.62-.15-1.12-.29-1.51-.44-.39-.15-.73-.38-1.01-.71-.28-.32-.42-.75-.42-1.29,0-.47.13-.9.38-1.28.25-.38.64-.68,1.15-.91s1.14-.34,1.88-.34c.52,0,1.02.06,1.51.19s.93.3,1.29.53l-.58,1.42c-.75-.42-1.5-.64-2.24-.64-.52,0-.91.08-1.16.25-.25.17-.38.39-.38.67s.14.48.43.62.73.27,1.32.4c.62.15,1.12.29,1.51.44.39.15.73.38,1.01.69.28.32.42.74.42,1.28,0,.46-.13.88-.39,1.27-.26.38-.65.68-1.16.91s-1.14.33-1.88.33c-.64,0-1.26-.09-1.86-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M821.28,243.48c.53.24.93.58,1.22,1.02s.43.96.43,1.56-.14,1.11-.43,1.56-.69.78-1.22,1.02c-.53.24-1.15.35-1.87.35h-1.63v2.23h-1.87v-8.1h3.5c.72,0,1.34.12,1.87.36ZM820.59,247.1c.29-.24.44-.59.44-1.04s-.15-.8-.44-1.05c-.29-.24-.72-.36-1.28-.36h-1.53v2.81h1.53c.56,0,.99-.12,1.28-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M826.02,250.81c-.67-.36-1.2-.86-1.58-1.5s-.57-1.35-.57-2.15.19-1.51.57-2.15c.38-.64.91-1.13,1.58-1.5.67-.36,1.43-.54,2.27-.54s1.6.18,2.27.54c.67.36,1.2.86,1.58,1.5.39.64.58,1.35.58,2.15s-.19,1.51-.58,2.15-.91,1.14-1.58,1.5c-.67.36-1.43.54-2.27.54s-1.6-.18-2.27-.54ZM829.58,249.43c.38-.22.69-.53.91-.92s.33-.84.33-1.34-.11-.95-.33-1.34c-.22-.39-.52-.7-.91-.92-.39-.22-.82-.33-1.3-.33s-.91.11-1.29.33-.69.53-.91.92c-.22.39-.33.84-.33,1.34s.11.95.33,1.34.52.7.91.92.82.33,1.29.33.91-.11,1.3-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M839.29,251.22l-1.56-2.25h-1.72v2.25h-1.87v-8.1h3.5c.72,0,1.34.12,1.87.36.53.24.93.58,1.22,1.02s.43.96.43,1.56-.14,1.12-.43,1.56-.7.77-1.23,1l1.82,2.6h-2.01ZM838.81,245.01c-.29-.24-.72-.36-1.28-.36h-1.53v2.82h1.53c.56,0,.99-.12,1.28-.37.29-.25.44-.59.44-1.04s-.15-.8-.44-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M844.19,244.65h-2.59v-1.53h7.05v1.53h-2.59v6.57h-1.87v-6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M849.66,243.12h1.87v8.1h-1.87v-8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M854.26,251.1c-.6-.17-1.08-.4-1.44-.68l.64-1.41c.35.25.76.46,1.24.61.48.15.96.23,1.43.23.53,0,.93-.08,1.18-.24.25-.16.38-.37.38-.63,0-.19-.08-.35-.23-.48s-.34-.23-.58-.31-.55-.16-.95-.25c-.62-.15-1.12-.29-1.51-.44-.39-.15-.73-.38-1.01-.71-.28-.32-.42-.75-.42-1.29,0-.47.13-.9.38-1.28.25-.38.64-.68,1.15-.91s1.14-.34,1.88-.34c.52,0,1.02.06,1.51.19s.93.3,1.29.53l-.58,1.42c-.75-.42-1.5-.64-2.24-.64-.52,0-.91.08-1.16.25-.25.17-.38.39-.38.67s.14.48.43.62.73.27,1.32.4c.62.15,1.12.29,1.51.44.39.15.73.38,1.01.69.28.32.42.74.42,1.28,0,.46-.13.88-.39,1.27-.26.38-.65.68-1.16.91s-1.14.33-1.88.33c-.64,0-1.26-.09-1.86-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M862.39,244.65h-2.59v-1.53h7.05v1.53h-2.59v6.57h-1.87v-6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M872.79,249.48h-3.76l-.72,1.73h-1.92l3.61-8.1h1.85l3.62,8.1h-1.97l-.72-1.73ZM872.2,248.06l-1.28-3.1-1.28,3.1h2.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M530.77,46.87c-.86-.89-2.05-1.3-3.27-1.13l-1.8.25c-5.5.76-10.57,3.46-14.28,7.58l-1.54,1.71-7.8-1.92h.01s-9.17-2.26-9.17-2.26h0s-8.94-2.19-8.94-2.19c-.33-.08-.68.01-.92.25l-4.23,4.07c-.22.21-.33.5-.3.8.02.23.12.43.27.59.05.05.11.1.17.14l19.69,13.02-9.03,10.04-12.46-.98c-.28-.02-.56.08-.76.27l-3.72,3.58c-.23.22-.34.55-.29.86.03.2.13.39.26.53.08.08.17.15.28.2l11.14,5.45-.07.21c-.36,1.15-.07,2.35.76,3.21h0c.83.87,2.02,1.2,3.18.88l.21-.06,5.02,11.34c.05.11.11.2.19.29.14.14.32.24.52.28.32.06.64-.03.87-.26l3.72-3.58c.2-.2.31-.47.3-.75l-.51-12.49,10.38-8.64,12.26,20.17c.04.06.08.12.13.17.15.16.36.26.58.29.3.04.6-.06.81-.27l4.23-4.07c.24-.23.35-.58.28-.91l-1.86-9.02h0s-1.91-9.26-1.91-9.26h0s-1.62-7.86-1.62-7.86l1.76-1.47c4.27-3.55,7.15-8.52,8.12-13.98l.32-1.79c.22-1.21-.15-2.42-1.01-3.31ZM481.08,53.79l2.95-2.84,24.36,5.99-8.4,9.35-18.91-12.5ZM524.91,93.43l-2.95,2.84-11.77-19.37,9.66-8.04,5.06,24.57ZM529.83,49.83l-.32,1.79c-.89,5.01-3.53,9.56-7.44,12.81l-25.43,21.17c-.12.1-.24.19-.36.28l.52,13.05-2.38,2.29-5.04-11.65c-.3.1-.6.19-.91.27l-1.03.28c-.45.12-.92,0-1.25-.34h0c-.33-.34-.44-.81-.3-1.26l.32-1.02c.1-.34.24-.65.36-.98l-11.51-5.4,2.38-2.29,12.9,1.18c.14-.17.27-.35.42-.52l22.12-24.61c3.4-3.78,8.05-6.25,13.08-6.95l1.8-.25c.59-.08,1.16.12,1.57.54.41.43.59,1.01.48,1.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunaNew);
export default __webpack_public_path__ + "static/media/luna_new.15033f4290af71162ad04d36ca70fbbf.svg";
export { ForwardRef as ReactComponent };